import React from 'react';
import { Terminal, Cpu, Smartphone, User, Code, Layout, Send, X, Minus, Square } from 'lucide-react';

function App() {
  return (
      <div className="min-h-screen w-full bg-[#0078d7] flex items-center justify-center p-4 font-sans selection:bg-blue-500 selection:text-white"
           style={{
             backgroundImage: 'radial-gradient(circle at center, #0078d7 0%, #005a9e 100%)',
             backgroundSize: 'cover'
           }}>

        {/* Windows 10 Window Case */}
        <div className="w-full max-w-3xl bg-[#f0f0f0] shadow-2xl border border-[#0078d7] flex flex-col overflow-hidden transition-all">

          {/* Title Bar */}
          <div className="bg-white h-8 flex items-center justify-between pl-3 select-none">
            <div className="flex items-center gap-2">
              <Terminal size={14} className="text-gray-600" />
              <span className="text-[11px] text-gray-700 font-medium">C:\Users\linuxdev\portfolio.exe</span>
            </div>
            <div className="flex h-full text-gray-600">
              <div className="px-4 flex items-center hover:bg-gray-200 transition-colors cursor-default"><Minus size={14} /></div>
              <div className="px-4 flex items-center hover:bg-gray-200 transition-colors cursor-default"><Square size={10} /></div>
              <div className="px-4 flex items-center hover:bg-[#e81123] hover:text-white transition-colors cursor-default group">
                <X size={14} />
              </div>
            </div>
          </div>

          {/* Action Menu */}
          <div className="bg-[#f0f0f0] px-2 py-0.5 border-b border-gray-300 flex gap-3 text-[11px] text-gray-700">
            <span className="cursor-default hover:text-blue-600">File</span>
            <span className="cursor-default hover:text-blue-600">View</span>
            <span className="cursor-default hover:text-blue-600">Debug</span>
            <span className="cursor-default hover:text-blue-600">Help</span>
          </div>

          {/* Main Content Area */}
          <div className="p-6 sm:p-10 bg-white overflow-y-auto max-h-[85vh]">

            {/* Header */}
            <div className="flex flex-col sm:row items-center sm:items-start gap-6 mb-8 pb-6 border-b border-gray-100 text-center sm:text-left">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 border border-gray-200 shadow-inner shrink-0">
                <User size={40} />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900 tracking-tight uppercase">Egor // linuxdev</h1>
                <p className="text-blue-600 font-semibold text-sm">System Administrator & Developer</p>
                <p className="text-[10px] text-gray-400 mt-1 uppercase tracking-widest">Kanash, Russia // Available for hire</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

              {/* System Info */}
              <div className="space-y-4">
                <h3 className="flex items-center gap-2 font-bold text-gray-800 text-xs uppercase tracking-wider border-l-4 border-blue-500 pl-2">
                  <Cpu size={16} /> Hardware Specs
                </h3>
                <div className="bg-gray-50 p-4 border border-gray-200 font-mono text-[12px] leading-relaxed">
                  <p className="flex justify-between border-b border-gray-100 py-1">
                    <span className="text-gray-400">OS:</span>
                    <span className="font-bold">Windows 11 Pro</span>
                  </p>
                  <p className="flex justify-between border-b border-gray-100 py-1">
                    <span className="text-gray-400">CPU:</span>
                    <span className="font-bold">i5-12400F</span>
                  </p>
                  <p className="flex justify-between border-b border-gray-100 py-1">
                    <span className="text-gray-400">GPU:</span>
                    <span className="font-bold">GTX 1650</span>
                  </p>
                  <p className="flex justify-between py-1">
                    <span className="text-gray-400">RAM:</span>
                    <span className="font-bold">16 GB DDR4</span>
                  </p>
                  <div className="mt-3 pt-2 text-[11px] flex items-center gap-2 text-gray-500">
                    <Smartphone size={12} />
                    <span>Daily: Redmi Note 14 4G</span>
                  </div>
                </div>
              </div>

              {/* Software Info */}
              <div className="space-y-4">
                <h3 className="flex items-center gap-2 font-bold text-gray-800 text-xs uppercase tracking-wider border-l-4 border-blue-500 pl-2">
                  <Code size={16} /> Tech Stack
                </h3>
                <div className="flex flex-wrap gap-1.5">
                  {['JetBrains', 'VS 2026', 'Godot', 'Adobe', 'React', 'Linux'].map(tool => (
                      <span key={tool} className="px-2 py-1 bg-white border border-gray-300 text-[10px] font-bold shadow-sm rounded hover:bg-gray-50 transition-colors">
                    {tool}
                  </span>
                  ))}
                </div>
                <p className="text-gray-600 text-xs leading-relaxed mt-2">
                  Specializing in system optimization, game development, and software design. Passionate about AI integration and low-level system performance.
                </p>
              </div>
            </div>

            {/* Contact Button */}
            <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col items-center">
              <a
                  href="https://t.me/defaultuser002"
                  className="flex items-center gap-3 bg-[#0078d7] text-white px-10 py-3 font-bold text-sm hover:bg-[#005a9e] active:scale-95 transition-all shadow-md"
              >
                <Send size={16} />
                CONTACT VIA TELEGRAM
              </a>
              <div className="mt-6 text-[9px] text-gray-300 font-mono tracking-tighter uppercase">
                Build Version: 1.0.4-LTSC // Kernel: 6.1.0-custom
              </div>
            </div>

          </div>
        </div>
      </div>
  );
}

export default App;